import { CheckIcon, PlusIcon } from "@heroicons/react/24/solid"
import { StudentStatus } from "toptaal-shared"

export function getWebCalendarStatusLabel(status: StudentStatus): {
  text: string
  icon?: React.ReactNode
  color?: string
} {
  switch (status) {
    case "registered":
      return {
        text: "",
      }
    case "present":
      return {
        text: "Aanwezig",
        icon: (
          <CheckIcon
            style={{ color: "var(--color-primary-green)" }}
            width={16}
            height={16}
          />
        ),
        color: "text-primary-green",
      }
    case "absent_excused":
      return {
        text: "Afwezig",
        icon: (
          <PlusIcon
            style={{
              color: "var(--color-secondary-coral)",
              transform: "rotate(45deg)",
            }}
            width={16}
            height={16}
          />
        ),
        color: "text-secondary-coral",
      }
    case "absent_unexcused":
      return {
        text: "Afwezig",
        icon: (
          <PlusIcon
            style={{
              color: "var(--color-secondary-coral)",
              transform: "rotate(45deg)",
            }}
            width={16}
            height={16}
          />
        ),
        color: "text-secondary-coral",
      }
    default:
      return {
        text: "",
      }
  }
}
